import { useState } from "react";
import BG2 from "../../../assets/images/core/profile/bg2.png"

export const ProfileState = () => {
    const [validDate, setValidDate] = useState(false);
    const [invalidNo, setInvalidNo] = useState(false);
    const [errors, setErrors] = useState({ 
        first_name: false,
        last_name: false,
        suffix: false,
        profession: false,
        email_address: false,
        prc_license_num: false,
        prc_expiry_date: false,
    });
    const [pData, setPData] = useState({profile: '', profile_pic:'', first_name: '' , middle_name:'', last_name: '', suffix: '', email_address: '', prc_id_expiry_date:'', profession:'', prc_license:null, mobile_num:'' });
    const [loader, setLoader] = useState(false);
    const [successSaving, setSuccessSaving] = useState(false);
    const [form, setForm] = useState({
        step: 1,
        inputs: {
            first_name: {value: '', stat: false, msg: ''},
            last_name: {value: '', stat: false, msg: ''},
            suffix: {value: '', stat: false, msg: ''},
            profession: {value: '', stat: false, msg: ''},
            license: {value: '', stat: false, msg: ''},
            prc_license_num: {value: '', stat: false, msg: ''},
            prc_expiry_date: {value: '', stat: false, msg: ''},
            file: {value: null, object: BG2, name: 'default_avatar', type: 'default', size: 0, updated: false, stat: false, msg: ''}
        }
    })
    const [esform, setEsForm] = useState({
        step: 1,
        load: false,
        resend: {},
        verification: {step: 1, stat: false},
        inputs: {
            email: {value: '', validated: false, stat: false, msg: ''},
            vc: {current: '', value: '', stat: false, msg: ''}
        }
    })
    const [resend, setResend] = useState({time: 320, stat: 0, msg: 'Resend code after'})

    const [isLoader, setIsLoader] = useState(false);
    const [isProgress, setIsProgress] = useState(false);

    return {
        validDate:{ data: validDate, set: setValidDate},
        invalidNo:{ data: invalidNo, set: setInvalidNo},
        errors:{ data: errors, set: setErrors},
        loader:{ data: loader, set: setLoader},
        successSaving: {data: successSaving, set: setSuccessSaving},
        form: {data: form, set: setForm},
        esform: {data: esform, set: setEsForm},
        resend: {data: resend, set: setResend},
        pData: {data: pData, set: setPData},

        isLoader: {data: isLoader, set: setIsLoader},
        isProgress: {data: isProgress, set: setIsProgress},
    }
}
